var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"id":"call-stats-table","loading":_vm.loading,"loading-text":"Downloading... Please wait...","items-per-page":_vm.itemsPerPage,"headers":_vm.headers,"calculate-widths":true,"items":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }